import { Button, Typography } from "@mui/material";
import React, { useMemo } from "react";
import styled from "styled-components";

import PropTypes from "prop-types";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const AppointmentFormStatus = ({ appointment_state_request_state, user_data }) => {
  const { status, id, issue_with_appointment } = appointment_state_request_state;
  const isAuthorizedStaff = ["Manager", "Admin", "Medical"].includes(user_data.account_type);
  // TODO move api calls to seperate file.
  const resolveIssue = async () => {
    const response = await axios.post(`/resolve_denial_of_request.json`, {
      appointment_request_id: id
    });
    if (response.status < 200 || response.status > 200) {
      toastr.error("Error failed to resolve request. Please try again or reach out to admin.");
      return;
    }
    toastr.success(
      "Appointment resolved successfully, starting refresh to load new appointment state"
    );
    window.location.reload();
  };

  const confirmUpdate = async () => {
    const response = await axios.post(`/confirm_update.json`, {
      appointment_request_id: id
    });
    if (response.status < 200 || response.status > 200) {
      toastr.error("Error failed to resolve request. Please try again or reach out to admin.");
      return;
    }
    toastr.success(
      "Appointment resolved successfully, starting refresh to load new appointment state"
    );
    window.location.reload();
  };

  const colorPallet = useMemo(() => {
    if (status === "matched")
      return { textColor: "#155724", backgroundColor: "#d4edda", borderColor: "#c3e6cb" };
    if (status === "unmatched")
      return { textColor: "#856404", backgroundColor: "#fff3cd", borderColor: "#ffeeba" };
    if (status === "need_update_confirmation")
      return { textColor: "#0c5460", backgroundColor: "#d1ecf1", borderColor: "#bee5eb" };
    if (status === "denied")
      return { textColor: "#721c24", backgroundColor: "#f8d7da", borderColor: "#f5c6cb" };
    return { textColor: "#000000", backgroundColor: "#ffffff", borderColor: "#dddddd" }; // Default fallback
  }, [status]);

  const statusDislpayText = useMemo(() => {
    return status.replaceAll("_", " ");
  }, [appointment_state_request_state]);

  return (
    <Container
      $borderColor={colorPallet.borderColor}
      $backgroundColor={colorPallet.backgroundColor}
    >
      <StatusText $textColor={colorPallet.textColor}>Status: {statusDislpayText}</StatusText>
      <WhatUpdated>{issue_with_appointment}</WhatUpdated>
      {user_data.account_type == "Peer" && status == "need_update_confirmation" && (
        <StyledButton variant="outlined" $textColor={colorPallet.textColor} onClick={confirmUpdate}>
          Confirm Update
        </StyledButton>
      )}
      {status == "denied" && (
        <>
          <ReasonForDenial variant="outlined" $textColor={colorPallet.textColor}>
            Reason For Denial: {issue_with_appointment}
          </ReasonForDenial>
          {isAuthorizedStaff && (
            <>
              <StyledButton
                variant="outlined"
                onClick={resolveIssue}
                $textColor={colorPallet.textColor}
              >
                Resolve Issue
              </StyledButton>
              <InfoAboutResolving $textColor={colorPallet.textColor}>
                *If you update the request, it will remove the denial and ask the peer to confirm
                the update.
              </InfoAboutResolving>
            </>
          )}
        </>
      )}
    </Container>
  );
};

AppointmentFormStatus.propTypes = {
  appointment_state_request_state: PropTypes.object,
  user_data: PropTypes.object
};

export default AppointmentFormStatus;

const StyledButton = styled(Button)`
  && {
    color: ${({ $textColor }) => $textColor};
    border-color: ${({ $textColor }) => $textColor};
    margin: 1rem 0;
  }
`;

const Container = styled.div`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border: solid black thin;
  border-color: ${({ $borderColor }) => $borderColor};
  border-radius: 2rem;
  padding: 1rem;
`;

const ReasonForDenial = styled.h4`
  color: ${({ $textColor }) => $textColor};
`;

const InfoAboutResolving = styled.p`
  font-size: 1rem;
  color: ${({ $textColor }) => $textColor};
`;

const StatusText = styled(Typography)`
  && {
    font-size: 2rem;
    text-transform: capitalize;
    font-weight: bolder;
    color: ${({ $textColor }) => $textColor};
  }
`;

const WhatUpdated = styled(Typography)`
  && {
    font-size: 1rem;
    text-transform: capitalize;
    font-weight: bolder;
    color: ${({ $textColor }) => $textColor};
  }
`;
